import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import http from 'src/helper/http'
import './index.less'
import { getlang, setlang } from 'src/helper/getlang'
import Message from '../../../component/Message'
import langM from './lang'
import { setDocumentTitle, setUidToken, isRtl } from 'src/helper/tool'
import localstorage from 'src/helper/localstorage'
@inject('store')
@observer
export default class extends React.Component {
  state = {
    lang:langM.en,
    language:'en',
    userUid:'',
    historyList:[]
  }

  async componentWillMount() {
    //设置语言 start
    let { language } = this.props.location.query
    language =await getlang(language)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    if (this.state.language == 'tr') {
      setDocumentTitle('Yeni Yayıncı Davet Et')
    } else if (this.state.language == 'en') {
      setDocumentTitle('Invite New Host')
    }else if (this.state.language == 'ar') {
      setDocumentTitle('  دعوة مضيف جديد')
    }

    // end
    let uid = await setUidToken(this.props.location.query)
    console.log(uid, 'uni')
    this.getHistory()
  }
  setValue = (e)=>{
    console.log(e.target.value)
    this.setState({userUid:e.target.value})
  }
  findUser = async()=>{
    let {userUid} = this.state
    let res = await http.post('/web/user/info', { uidDuid:userUid })
    if (!userUid) return
    if (res.code ==0 && res.res) {
      this.setState({ueriInfo:res.res})
    }else {
       this.refs.msg.show(this.state.lang.notExist)
    }
    
  }
  addHost = async()=>{
     let {ueriInfo} = this.state
     let {hostSystemId} = localstorage.get('hostSystem')
     if (!ueriInfo) return
     let res = await http.post('/web/hostsystem/invite/apply', { hostSystemId,uid:ueriInfo.uid })
     if (res.code == 0 ) {
      
      this.refs.msg.show(this.state.lang.successful)
      this.getHistory()
     }else{
      this.refs.msg.show(this.state.lang.haveHost)
     }
  }
  getHistory = async()=>{
    let {uid,hostSystemId} = localstorage.get('hostSystem')
    let res = await http.post('/web/hostsystem/invite/record',{hostSystemId})
    console.log('res',res)
    if (res.code == 0 && res.res) {
      this.setState({historyList:res.res})
    }
  }
  render() {
    let { lang , ueriInfo, userUid, historyList,language } = this.state
    return (
      <div  className={`invite-new-host ${isRtl(language) ? 'in-tr':''}` }>
        <div className="find-user">
          <div className="find-hanlde-view">
            <input className="input-root" onChange={e=>this.setValue(e)} placeholder={lang.enterID}></input>
            <div className="find-line"></div>
            <div className={`find-btn ${userUid.length>0?'havevalue':''}`} onClick={this.findUser}>{lang.find}</div>
          </div>
          {ueriInfo && <div className="application-user-info">
            <div className="avatar-root">
              <img className="avatar-img" src={ueriInfo.avatarurl}></img>
              {ueriInfo.gender == 1 && <img className="img-gender" src='/img/app/tradeUnion/man_icon.png'></img>}
              {ueriInfo.gender == 2 && <img className="img-gender" src='/img/app/tradeUnion/women_icon.png'></img>}
            </div>
            <div className="user-infos">
              <div className="user-info-top">
                <div className="top-text">{ueriInfo.nickname}</div>
              </div>
              <div className="user-info-buttom">ID:{ueriInfo.uid}</div>
            </div>
          </div>}
          <div className={`invite ${ueriInfo?'':'on-userinfo'}`} onClick={this.addHost}>{lang.invite}</div>
        </div>
        <div className='invite-history'>
          <div className='history-title'>{lang.inviteHistory}</div>
          <div className="info-title-after"></div>
          <div className='table-coums'>
             <div className='item-text'>{lang.inviteID}</div>
             <div className='item-text'>{lang.invitees}</div>
             <div className='item-text'>{lang.timeInvited}</div>
          </div>
          <div className='test-root'>{historyList.length>0 && historyList.map((item,index)=>{return(<div className='list-item' key={index}>
            <div className='item-id'>{item.inviter}</div>
            <div className="user-bg">
            <div className="avatar-root">
              <img className="avatar-img" src={item.InviteeAvatarurl}></img>
              {item.InviteeGender == 1 && <img className="img-gender" src='/img/app/tradeUnion/man_icon.png'></img>}
              {item.InviteeGender == 2 && <img className="img-gender" src='/img/app/tradeUnion/women_icon.png'></img>}
            </div>
            <div className="user-infos">
              <div className="user-info-top">
                <div className="top-text">{item.InviteeNickname}</div>
              </div>
              <div className="user-info-buttom">ID:{item.InviteeDuid}</div>
            </div>
          </div>
            <div className='item-time'>{item.timeInvited}</div>
          </div>)})}</div>
          
        </div>
        <Message ref="msg" />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/invite-new-host/index.js